// import request from '@/utils/request'

// // 请求所有文章
// export const articleDirectory = (data) => {
//     return request({
//         url: '/web/articleDirectory',
//         method: 'post',
//         data
//     })
// }
// // 请求首页文章
// export const homePageContent = () => {
//     return request({
//         url: '/web/homePageContent',
//         method: 'post'
//     })
// }
// // 请求文章内容
// export const getArticleDetailById = (params) => {
//     return request({
//         url: '/web/getArticleDetailById',
//         method: 'post',
//         params
//     })
// }
// // 请求产品列表
// export const getProductList = () => {
//     return request({
//         url: '/web/getProductList',
//         method: 'post'
//     })
// }
// // 请求公司基本信息
// export const getCompanyInfo = () => {
//     return request({
//         url: '/web/getCompanyInfo',
//         method: 'post'
//     })
// }
// // 请求站点信息
// export const getSiteInfo = () => {
//     return request({
//         url: '/web/getSiteInfo',
//         method: 'post'
//     })
// }

import { articles } from '@/data'

// Promise封装
const __Promise = (info) => {
    return new Promise((resolve, reject) => {
        try {
            resolve(info);
        } catch (e) {
            reject({
                data: {
                    msg: e,
                    result: 500,
                },
                status: 500
            })
        }
    })
}

// 请求公司基本信息
export const getCompanyInfo = () => {
    const info = {
        data: {
            data: {
                id: 1,
                address: "广州市南沙区南沙街金隆路37号101-103房",
                blicense: "",
                contact: "",
                email: "xbdang@gzjanus.com",
                mobile: "",
                name: "广州鹤和健康科技有限公司",
                postCode: "",
                weixin: ""
            },
            result: 0
        },
        status: 200
    }

    return __Promise(info)
}

// 请求站点信息
export const getSiteInfo = () => {
    const info = {
        data: {
            data: {
                copyright: "",
                description: "",
                domain: "www.hubanhealth.com",
                icp: "粤ICP备2025449224号-1",
                id: 1,
                keyWords: "",
                logo: require('@/assets/img/public/logo@2x.png'),
                statistical: "",
                subTitle: "",
                theme: "",
                title: ""
            },
            result: 0
        },
        status: 200
    }

    return __Promise(info)
}

// 请求产品列表
export const getProductList = (bigCode = 2) => {
    const list = articles.filter(item => item.bigCode === Number(bigCode))
    const info = {
        data: {
            data: list,
            result: 0
        },
        status: 200
    }

    return __Promise(info)
}

// 请求所有文章
export const articleDirectory = ({ currentPage, pageSize, bigCode }) => {
    // 1.筛选目前数据
    const result = articles.filter(item => item.bigCode === Number(bigCode))
    //  2.分页
    const startIndex = (currentPage - 1) * pageSize;
    const endIndex = startIndex + pageSize;
    const list = result.slice(startIndex, endIndex);
    const info = {
        data: {
            data: list,
            page: {
                cuPage: currentPage,
                pageSize,
                count: result.length,
                totalPage: Math.ceil(result.length / pageSize)
            },
            result: 0
        },
        status: 200
    }

    return __Promise(info)
}

// 请求文章内容
export const getArticleDetailById = ({ articleId }) => {

    const info = {
        data: {
            data: {},
            result: 0
        },
        status: 200
    }

    info.data.data = articles.filter(item => item.id === Number(articleId))[0]

    return __Promise(info)
}